import React, { useState } from 'react'
import {BsFillArrowRightCircleFill,BsFillArrowLeftCircleFill} from "react-icons/bs"
export default function CarouselFull({slides,index}) {

let[current,setCurrent] = useState(index);
let previousSlide = () =>{
    if(current === 0 ) setCurrent(slides.length -1);
    else setCurrent(current -1);
};

let nextSlide = () => {
    if(current === slides.length -1) setCurrent(0);
    else setCurrent(current +1)
}
const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  return (
    
    <div className=' overflow-hidden relative'>
    <div className={` flex transition ease-out duration-40 `}
    
    style={{ transform: `translateX(-${current * 100}%)` }}
    >
        {slides.map((s)=>{
            return  <img className={screenHeight>screenWidth?'w-screen p-1 ':'h-screen p-1 '} alt='PT2000' src={s}/> 
        })}
    </div>
    <div className=' absolute top-0 h-full w-full justify-between items-center flex text-gray-400 px-10 z-1 text-3xl'>
        <button onClick={previousSlide}>
            <BsFillArrowLeftCircleFill />
        </button>
        <button onClick={nextSlide}>
            <BsFillArrowRightCircleFill />
        </button>
    </div>
    </div>
  )
}
